import { defineComponent as _defineComponent } from 'vue';
import { ref, watch, reactive } from 'vue';
import moment from 'moment';
import Colors from '@/styles/color.scss';
export default /*#__PURE__*/ _defineComponent({
    __name: 'snapshot',
    emits: ['dateChange'],
    setup(__props, { emit }) {
        const colors = ref(Colors);
        const datePick = ref(null);
        // 快照时间选择
        let dataPicker = ref('');
        let pickerOptions = reactive({
            disabledDate: (date) => moment(date).isAfter(moment().format('YYYY-MM-DD 00:00')),
            selectableRange: '',
        });
        watch(dataPicker, (time) => {
            let nowDay = moment(new Date()).format('YYYY-MM-DD');
            let chooseDay = moment(time).format('YYYY-MM-DD');
            // 日期是否是今日  今日则禁选未来时间
            if (nowDay === chooseDay) {
                pickerOptions.selectableRange = '00:00:00 - ' + moment(new Date()).format('HH:mm:ss');
            }
            else {
                pickerOptions.selectableRange = '00:00:00 - 23:59:59';
            }
        });
        // 快照事件
        let isSnapshot = ref(false);
        let date = ref('');
        const loseFocus = () => {
            // 防止弹出时间选择器但是没有选时间的情况
            if (!date.value) {
                isSnapshot.value = false;
            }
        };
        const onConfirm = (time) => {
            date.value = time || dataPicker.value;
        };
        const onClick = () => {
            date.value = '';
            dataPicker.value = '';
            if (isSnapshot.value) {
                datePick.value.focus();
            }
        };
        const onMouseEnter = () => {
            if (isSnapshot.value) {
                datePick.value.focus();
            }
        };
        watch(date, (time) => {
            emit('dateChange', time);
        });
        return { __sfc: true, emit, colors, datePick, dataPicker, pickerOptions, isSnapshot, date, loseFocus, onConfirm, onClick, onMouseEnter };
    }
});
